import React from 'react';
import { Eye, MoreHorizontal, Pencil, Trash2 } from 'lucide-react';

import { Button } from '@/shared/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/ui/dropdown-menu';

interface RecordActionsMenuProps {
  label: string;
  canEdit: boolean;
  canDelete: boolean;
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const RecordActionsMenu: React.FC<RecordActionsMenuProps> = ({
  label,
  canEdit,
  canDelete,
  onView,
  onEdit,
  onDelete,
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-8 w-8 p-0"
        aria-label={`Actions for ${label}`}
        title="Actions"
        onClick={(event) => event.stopPropagation()}
      >
        <MoreHorizontal className="h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent
      align="end"
      className="w-40"
      onClick={(event) => event.stopPropagation()}
    >
      <DropdownMenuItem onSelect={onView}>
        <Eye className="mr-2 h-4 w-4" />
        View
      </DropdownMenuItem>
      <DropdownMenuItem disabled={!canEdit} onSelect={onEdit}>
        <Pencil className="mr-2 h-4 w-4" />
        Edit
      </DropdownMenuItem>
      <DropdownMenuItem
        disabled={!canDelete}
        onSelect={onDelete}
        className="text-destructive focus:text-destructive"
      >
        <Trash2 className="mr-2 h-4 w-4" />
        Delete
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

export default RecordActionsMenu;
